import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { roles } from 'src/utils/roles';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { PageTransition } from 'src/components/animate/page-transition';

import { AuthGuard, RoleBasedGuard, FeatureFlagGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

// Pages
const ChatPage = lazy(() => import('src/pages/chat/chat'));
const ChatUsagePage = lazy(() => import('src/pages/chat/chat-usage'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <PageTransition>
        <Outlet />
      </PageTransition>
    </Suspense>
  </DashboardLayout>
);

export const chatRoutes = [
  {
    path: 'chat',
    element: CONFIG.auth.skip
      ? <FeatureFlagGuard feature="chat"><RoleBasedGuard roles={[roles.AI]}>{layoutContent}</RoleBasedGuard></FeatureFlagGuard>
      : <AuthGuard><FeatureFlagGuard feature="chat"><RoleBasedGuard roles={[roles.AI]}>{layoutContent}</RoleBasedGuard></FeatureFlagGuard></AuthGuard>,
    children: [
      { element: <ChatPage />, index: true },
      { path: 'usage', element: <ChatUsagePage /> },
    ],
  },
];
